import React, { useContext, useState } from 'react';
import NewButton from '../../../NewComponents/NewButton';
import { NotificationContext } from '../../../Context/NotificationContext';
import { firestore } from '../../../firebase.config';

const OrderTranslationAfterApprove = ({ orderInfo, notarizationService, hardCopyService ,trackingID,setShowTranslationApproval }) => {


  const { showNotification } = useContext(NotificationContext);
  const handleSave = () => {

    // Prepare update data and remove undefined fields
    let updateData = {};

    if (notarizationService) {
      updateData.notarizationStatus = notarizationService ? "completed" : orderInfo.notrizationStatus;
    }
    if (hardCopyService) {
      updateData.hardCopyStatus = hardCopyService ? "shipped" : orderInfo.hardCopyStatus;
    }

    if (trackingID) {
      updateData.hardCopyTrackingID = trackingID;
    }

    // Check if there's anything to update
    if (Object.keys(updateData).length === 0) {
      showNotification("Error", "No valid changes to save.", "error");
      return;
    }

    firestore
      .collection("orders")
      .doc(orderInfo.id)
      .update(updateData)
      .then(() => {
        showNotification("Success", "Saved successfully.", "success");
        setShowTranslationApproval(false); 
      })
      .catch(() => {
        showNotification("Error", "An error occurred while saving. Please try again.", "error");
      });
  };
  const isSaveEnabled = notarizationService === true || hardCopyService === true;
  return (
    <>
      <div className="orderSummary">
        <h2 className="orderSummaryTitle">Translation</h2>
        {
          orderInfo.status === "completed" && <>

            {notarizationService && hardCopyService ? (
              <p className='revisionTextWarning'>
                After saving, the client will receive a notification that the notarization has been completed and the mail hard copy has been shipped.
              </p>
            ) : (
              <>

                {notarizationService && !hardCopyService && (
                  <p className='revisionTextWarning'>
                    After saving, the client will receive a notification that the notarization has been completed.
                  </p>
                )}

                {hardCopyService && !notarizationService && (
                  <p className='revisionTextWarning'>
                    After saving, the client will receive a notification that the mail hard copy has been shipped.
                  </p>
                )}
              </>
            )}


            <NewButton
              text="Save"
              onClick={handleSave}
              icon={false}
              width='100%'
              disabled={!isSaveEnabled}
            />
          </>
        }
      </div>
    </>
  );
};

export default OrderTranslationAfterApprove;
